import instance from 'api/instance';

export const getBranches = () => instance.get('/public/branches');
